module.exports = __webpack_public_path__ + "img/profile_image.03b8549f.jpg";